module.exports = __webpack_public_path__ + "img/12_36.d0b03c00.png";